const VARIANTS = ['primary', 'secondary', 'accent', 'danger', 'ghost'];
const SIZES = ['sm', 'md'];

export function buttonClasses({
  variant = 'secondary',
  size = 'md',
  iconOnly = false,
  fullWidth = false,
  className = '',
} = {}) {
  const v = VARIANTS.includes(variant) ? variant : 'secondary';
  const s = SIZES.includes(size) ? size : 'md';
  const parts = ['pz-btn', `pz-btn--${v}`, `pz-btn--${s}`];
  if (iconOnly) parts.push('pz-btn--icon');
  if (fullWidth) parts.push('pz-btn--block');
  const c = className.trim();
  if (c) parts.push(c);
  return parts.join(' ');
}
